import React from 'react';
import { footersSet } from './constants/footersSet';
import classnames from 'classnames';

import ModalPreviewer from '@components/ModalPreviewer/ModalPreviewer';
import { ShowCase, Preview, Controls } from '@components/ShowCase';

import styles from './Footers.css';

const Footers = () => (
  <section>
    <article>
      <ul className="showcase-list">
        {
          footersSet.map((footerPreview, i) => (
            <li key={`Footers-showcase-${i}`}>
              <ShowCase codeTemplate={footerPreview.codeTemplate}>
                <Preview className={footerPreview.previewClassName}>
                  <ModalPreviewer
                    previewText="Preview Footer"
                    imagePath={`footers/${footerPreview.imagePath}`}
                    className={footerPreview.modalPreviewClassName}
                    modalCustomClass={classnames(styles.modalClasses, 'flex flex-align-end')}
                  >
                    {footerPreview.component}
                  </ModalPreviewer>
                </Preview>
                <Controls optionsGroup={footerPreview.optionsGroup} />
              </ShowCase>
            </li>
          ))
        }
      </ul>
    </article>
  </section>
);

export default Footers;



// WEBPACK FOOTER //
// ./src/containers/components/Footer/Footers.js